import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import { getRegisterlist } from "./../../services/goodreceive";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { saveRC } from "./../../services/wms";
import moment from "moment";
import BranchContext from "./../context/branch";
import Input from "./../wms/input";
import Renderregister from "./renderregisterlist";

import ScrollToTop from "../common/ScrollToTop";
import ModalRC from "./zoomBhl";
const Registerlist = (props) => {
  let datalink = props.location.linkdetails;
  let cusId = 0;
  //console.log(datalink);
  if (datalink) {
    cusId = datalink.cusid;
  }

  const { currentBranch } = useContext(BranchContext);

  const [register, setregister] = useState([]);
  const [isOpen, setisOpen] = useState(false);
  const [subdata, setdata] = useState([]);
  const [cusid, setCusid] = useState(0);
  const [search, setSearch] = useState("");
  const [name, setname] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [vForm, setvForm] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [lastupdate, setlastupdate] = useState(new Date());
  const [onprocess, setonprocess] = useState(false);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    if (vForm) return;
    const getLinkdata = () => {
      if (datalink && !vForm) {
        const queuedate = new Date(datalink.ddate);
        // if (datalink.cusid) {
        setvForm(true);
        //  }

        setStartDate(queuedate);
        setEndDate(queuedate);
        setCusid(datalink.cusid);

        //  console.log(queuedate);
      } else {
        setvForm(true);
      }
    };
    getLinkdata();
  });

  useEffect(() => {
    if (!vForm) return;
    if (!currentBranch) return;

    setregister([]);
  }, [
    vForm,
    startDate,
    endDate,
    onprocess,
    currentBranch,
    search,
    cusid,
    pageSize,
    lastupdate,
  ]);

  useEffect(() => {
    if (!vForm) return;
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (onprocess) return;

    setLoading(true);
    setError(false);
    getRegisterlist(
      moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
      moment(endDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
      currentBranch && currentBranch._id,
      cusid,
      search,
      pageSize,
      pageNumber
    ).then((result) => {
      //console.log("test",result.data);
      setregister((prevData) => {
        return [...new Set([...prevData, ...result.data])];
      });
      setHasMore(result.data.length > pageSize - 1);
      setLoading(false);

      // setregister(result.data);
    });
  }, [
    vForm,
    startDate,
    endDate,
    onprocess,
    currentBranch,
    search,
    cusid,
    pageSize,
    pageNumber,
    lastupdate,
  ]);

  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleTextchange = (event) => {
    setname(event.target.value);
    // setPageNumber(1);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setSearch(name);
      setPageNumber(1);
    }
  };
  const handleSearchDrinvenClick = () => {
    setSearch(name);
    setPageNumber(1);
  };
  const handleConfirm = (doc) => {
    setonprocess(true);
    doSubmit(doc);
  };

  const doSubmit = async (doc) => {
    try {
      //console.log(doc)
      const { data: result } = await saveRC(doc);
      if (result.status === "success") {
        toast.success("บันทึกเสร็จเรียบร้อย");
        setlastupdate(new Date());
        setisOpen(false);
        setonprocess(false);
      } else {
        toast.error(result.message);
        setonprocess(false);
      }
    } catch (err) {
      toast.error("Error Try Catch");
    }
  };

  const handleCancel = (event) => {
    //setlastupdate(new Date());
    setisOpen(false);
  };
  const handleClick = (event) => {
    setdata([]);
    const subdata = register.filter((x) => x.AutoID === event);

    setdata(subdata);
    if (subdata.length > 0) {
      setisOpen(true);
    }
  };
  if (!vForm) {
    return <div></div>;
  }

  return (
    <>
      <ModalRC
        isOpen={isOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        list={subdata}
        branch={currentBranch._id}
      />

      <div className="col-lg-12">
        <div className="row ">
          <div className="col-auto ">
            <span className="badge bg-info text-dark mt-4" style={{ fontSize: "18px" }}>
              บันทึกรับสินค้ารถร่วม
            </span>
          </div>
          <div className="col-auto">
            <div className="m-2">
             <i>
                จากวันที่ <span className="label"></span>
              </i>

              <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
                <DatePicker
 className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleChangStartDate}
                />
              </div>
            </div>
          </div>
          <div className="col-auto">
            <div className="m-2">
             <i>
                ถึงวันที่ <span className="label"></span>
              </i>
              <div className="mt-2">
                <DatePicker
 className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={handleChangEndDate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
          <div className="form-group">
            <Input
              name="weightno"
              value={name}
              placeholder="ทะเบียนรถ เลขที่ใบชั่ง"
              onChange={handleTextchange}
              onKeyPress={handleKeyPress}
              onClick={handleSearchDrinvenClick}
              search="ค้นหา"
            />
          </div>
        </div>

        <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
          <div>&nbsp;</div>
          <button className="btn btn-success ">Download To Excel</button>
        </div>
      </div>
      <p className="text-success">
        แสดงข้อมูล {register ? register.length : 0} รายการ บนระบบ
      </p>
      {<ScrollToTop />}

      <Renderregister
        list={register}
        loading={loading}
        error={error}
        onClick={handleClick}
        lastBookElementRef={lastBookElementRef}
        // onProgress ={onProgress}
      />

      <div>{loading && "Loading..."}</div>
      <div>{error && "Error"}</div>
    </>
  );
};

export default Registerlist;
